var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_932_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 17.4167H1.58333C0.708882 17.4167 0 18.1256 0 19C0 19.8745 0.708882 20.5834 1.58333 20.5834H36.4167C37.2911 20.5834 38 19.8745 38 19C38 18.1256 37.2911 17.4167 36.4167 17.4167Z",
    fill: "#113C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 6.33331H1.58333C0.708882 6.33331 0 7.0422 0 7.91665C0 8.7911 0.708882 9.49998 1.58333 9.49998H36.4167C37.2911 9.49998 38 8.7911 38 7.91665C38 7.0422 37.2911 6.33331 36.4167 6.33331Z",
    fill: "#113C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4167 28.5H1.58333C0.708882 28.5 0 29.2089 0 30.0833C0 30.9578 0.708882 31.6667 1.58333 31.6667H36.4167C37.2911 31.6667 38 30.9578 38 30.0833C38 29.2089 37.2911 28.5 36.4167 28.5Z",
    fill: "#113C4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_1137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcons);
export default __webpack_public_path__ + "static/media/hamburger-icons.c158f994d2cc3a8775b48afb986c9b1a.svg";
export { ForwardRef as ReactComponent };